export const GENRES = [
  'Action',
  'Adventure', 
  'Animated',
  'Comedy',
  'Drama',
  'Fantasy',
  'Historical',
  'Horror',
  'Memoir',
  'Musical',
  'Mystery',
  'Non-Fiction',
  'Romance',
  'Sci-Fi',
  'Sports',
  'Thriller',
  'War',
  'Western'
] as const;

export type Genre = typeof GENRES[number];
